/** Contact channel a customer can choose for the confirmation nudge. */
export type ContactChannel = "email" | "phone";

/**
 * Customer-entered nudge recipient, collected before a reschedule/cancel
 * when the SAP order carries no EmailAddress or PhoneNumber of its own.
 */
export interface ContactInput {
  channel: ContactChannel;
  value: string;
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Whether the entered contact is complete enough to submit: a plausible
 * email, or a phone number with at least ten digits (formatting ignored).
 * The server re-sanitizes before sending, so this only gates the UI.
 */
export function isCompleteContact(contact: ContactInput): boolean {
  const trimmed = contact.value.trim();
  if (!trimmed) return false;
  if (contact.channel === "email") return EMAIL_PATTERN.test(trimmed);
  return trimmed.replace(/\D/g, "").length >= 10;
}
